import { isWithinRange } from "./is-within-range";

type CroppingOutput = {
  sx: number;
  sy: number;
  sw: number;
  sh: number;
};

export const calcCropping = (
  width: number,
  height: number,
  sx: number,
  sy: number,
  sw: number,
  sh: number,
): CroppingOutput => {
  if (sw < 0) sx += sw;
  if (sh < 0) sy += sh;

  sw = Math.abs(sw);
  sh = Math.abs(sh);

  const isXWithin = isWithinRange(sx, -sw + 1, width - 1);
  const isYWithin = isWithinRange(sy, -sh + 1, height - 1);
  const isWithin = isXWithin && isYWithin;

  if (!isWithin) return { sx: 0, sy: 0, sw: 0, sh: 0 };

  const toBeCroppedWidth = sw + sx;
  const toBeCroppedHeight = sh + sy;

  sx = Math.max(sx, 0);
  sy = Math.max(sy, 0);

  const maxDomainWidth = width + sw - toBeCroppedWidth;
  const maxDomainHeight = height + sh - toBeCroppedHeight;

  sw = Math.min(toBeCroppedWidth, sw, maxDomainWidth);
  sh = Math.min(toBeCroppedHeight, sh, maxDomainHeight);

  return { sx, sy, sw, sh };
};
